/* TWRD search guides.
   A small static map from search words to the guide and help pages, so the
   search overlay can answer "gsm", "refund" or "cringe" with a direct link,
   like a quick answer. Anchors match the ids the pages render
   (q-<question | handleize>, #weight-chart, help center card anchors).
   Exposes window.twrdSearchGuides.match(query) -> [{ title, hint, url }]. */
(function () {
  'use strict';

  var MAX_LINKS = 2;
  /* A query word must be at least this long to match a key by prefix
     ("shri" -> "shrink"). Shorter words need an exact hit, so "over" in
     "faith over fear" never reaches "oversized". */
  var MIN_PREFIX = 4;
  /* Small words that carry no topic. They never match a key on their own. */
  var STOP_WORDS = ['over', 'of', 'the', 'is', 'in', 'and', 'a', 'to'];

  var FABRIC = '/pages/fabric-guide';
  var FIT = '/pages/how-should-an-oversized-t-shirt-fit';
  var HELP = '/pages/help-center';
  var FAQ = '/pages/frequently-asked-questions';

  /* Each topic: the page link, the words that point to it, and question
     anchors that win when a more specific word matches. */
  var TOPICS = [
    {
      title: 'Fabric guide',
      hint: 'gsm, shrinkage, weight chart',
      url: FABRIC,
      keys: [
        'gsm', 'weight', 'heavy', 'heavyweight', 'fabric', 'cotton', 'thick', 'shrink',
        'shrinkage', 'wash', 'care', 'summer', 'oz', 'quality', '240', '260', '300', '400',
        'fleece', 'twist', 'fade', 'dryer', 'tumble'
      ],
      answers: [
        { title: 'Weight chart', keys: ['gsm', 'weight', 'chart', '260', '400'], hash: 'weight-chart' },
        { title: 'Does a 240 gsm tee shrink?', keys: ['shrink', 'shrinkage', 'shrunk', 'preshrunk'], hash: 'q-does-a-240-gsm-tee-shrink' },
        { title: 'Is 240 gsm heavyweight?', keys: ['heavy', 'heavyweight'], hash: 'q-is-240-gsm-heavyweight' },
        { title: 'Is 240 gsm too hot for summer?', keys: ['summer', 'hot', 'warm'], hash: 'q-is-240-gsm-too-hot-for-summer' },
        { title: 'How do I convert gsm to oz?', keys: ['oz', 'ounce', 'ounces', 'convert'], hash: 'q-how-do-i-convert-gsm-to-oz' },
        { title: 'How thick is a 240 gsm t-shirt?', keys: ['thick', 'thickness'], hash: 'q-how-thick-is-a-240-gsm-t-shirt' },
        { title: 'Is a 240 gsm t-shirt good quality?', keys: ['quality'], hash: 'q-is-a-240-gsm-t-shirt-good-quality' },
        { title: 'How do I wash a heavyweight tee?', keys: ['wash', 'washing', 'care', 'laundry'], hash: 'q-how-do-i-wash-a-heavyweight-tee-to-keep-its-shape' },
        { title: 'Can I tumble dry the hoodie and sweatpants?', keys: ['dryer', 'tumble'], hash: 'q-can-i-tumble-dry-the-hoodie-and-sweatpants' },
        { title: 'Why do some t-shirts twist after washing?', keys: ['twist', 'twisting'], hash: 'q-why-do-some-t-shirts-twist-after-washing' },
        { title: 'What is the difference between 240 gsm and 300 gsm?', keys: ['300'], hash: 'q-what-is-the-difference-between-240-gsm-and-300-gsm' },
        { title: 'Are the hoodie and sweatpants 100% cotton?', keys: ['fleece', 'cotton'], hash: 'q-are-the-hoodie-and-sweatpants-100-cotton' },
        { title: 'Will the colour fade?', keys: ['fade', 'fading'], hash: 'q-will-the-colour-fade' }
      ]
    },
    {
      title: 'Fit guide',
      hint: 'Size chart, oversized fit, how to measure',
      url: FIT,
      keys: [
        'fit', 'size', 'sizes', 'sizing', 'oversized', 'boxy', 'measure', 'measurements', 'chest',
        'length', 'tall', 'short', 'small', 'big', 'true to size', 'between sizes', 'unisex'
      ],
      answers: [
        { title: 'Is The Word true to size?', keys: ['true to size'], hash: 'q-is-the-word-true-to-size' },
        { title: 'What if I am between two sizes?', keys: ['between sizes', 'between'], hash: 'q-what-if-i-am-between-two-sizes' },
        { title: 'Should I size up for an oversized fit?', keys: ['oversized', 'boxy', 'size up'], hash: 'q-should-i-size-up-for-an-oversized-fit' },
        { title: 'How do I measure a shirt I already own?', keys: ['measure', 'measurements', 'chest'], hash: 'q-how-do-i-measure-a-shirt-i-already-own' },
        { title: 'Why are heavyweight tees short on tall people?', keys: ['tall', 'length'], hash: 'q-why-are-heavyweight-tees-short-on-tall-people' },
        { title: 'Does an oversized tee look good on short guys?', keys: ['short'], hash: 'q-does-an-oversized-tee-look-good-on-short-guys' },
        { title: 'Does an oversized tee work on skinny guys?', keys: ['skinny', 'small'], hash: 'q-does-an-oversized-tee-work-on-skinny-guys' },
        { title: 'Do oversized shirts make you look bigger?', keys: ['big', 'bigger'], hash: 'q-do-oversized-shirts-make-you-look-bigger' },
        { title: 'Are the tees unisex?', keys: ['unisex', 'women'], hash: 'q-are-the-tees-unisex' }
      ]
    },
    {
      title: 'Help center',
      hint: 'Returns, shipping, tracking, contact',
      url: HELP,
      keys: [
        'return', 'returns', 'refund', 'withdraw', 'exchange', 'swap', 'shipping', 'delivery',
        'track', 'tracking', 'order', 'customs', 'duty', 'duties', 'tax', 'faulty', 'broken',
        'damaged', 'wrong', 'contact', 'help'
      ],
      answers: [
        { title: 'Return or withdraw', keys: ['return', 'returns', 'refund', 'withdraw', 'withdrawal'], hash: 'returns' },
        { title: 'Exchange a size', keys: ['exchange', 'swap'], hash: 'exchange' },
        { title: 'Delivery times and cost', keys: ['shipping', 'delivery', 'ship'], hash: 'delivery' },
        { title: 'Track my order', keys: ['track', 'tracking'], hash: 'track' },
        { title: 'Customs and duties', keys: ['customs', 'duty', 'duties', 'tax', 'vat'], hash: 'customs' },
        { title: 'Faulty or wrong item', keys: ['faulty', 'broken', 'damaged', 'wrong', 'defect'], hash: 'fault' },
        { title: 'Contact a person', keys: ['contact', 'email'], hash: 'contact' }
      ]
    },
    {
      title: 'FAQ',
      hint: 'Faith, wearing it, made to order',
      url: FAQ,
      keys: [
        'christian', 'christians', 'cringe', 'preaching', 'church', 'believe', 'faith', 'work',
        'school', 'made to order', 'faq'
      ],
      answers: [
        { title: 'Is this cringe?', keys: ['cringe'], hash: 'q-is-this-cringe' },
        { title: 'Will I look like I am preaching?', keys: ['preaching', 'preach'], hash: 'q-will-i-look-like-i-am-preaching' },
        { title: 'Do I have to be Christian to wear it?', keys: ['christian', 'christians'], hash: 'q-do-i-have-to-be-christian-to-wear-it' },
        { title: 'Is this tied to a church, or to a political side?', keys: ['church', 'political'], hash: 'q-is-this-tied-to-a-church-or-to-a-political-side' },
        { title: 'Am I a hypocrite if I am not sure I believe yet?', keys: ['believe', 'faith', 'hypocrite'], hash: 'q-am-i-a-hypocrite-if-i-am-not-sure-i-believe-yet' },
        { title: 'Can I wear it to work, to the gym, to a family dinner?', keys: ['work', 'gym'], hash: 'q-can-i-wear-it-to-work-to-the-gym-to-a-family-dinner' },
        { title: 'Can I wear it to school, or if I teach?', keys: ['school', 'teach', 'teacher'], hash: 'q-can-i-wear-it-to-school-or-if-i-teach' },
        { title: 'Why is everything made to order?', keys: ['made to order'], hash: 'q-why-is-everything-made-to-order' }
      ]
    }
  ];

  function words(text) {
    return String(text || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(Boolean);
  }

  function topicWords(list) {
    return list.filter(function (w) {
      return STOP_WORDS.indexOf(w) < 0;
    });
  }

  /* One query word against one single-word key: an exact hit (whole word),
     the word is the start of the key ("shri" -> "shrink", 4+ letters), or the
     key is the start of the word ("refunds" -> "refund", key 4+ letters).
     Stop words are removed before this runs. */
  function wordHits(word, key) {
    if (word === key) return true;
    if (word.length >= MIN_PREFIX && key.indexOf(word) === 0) return true;
    return key.length >= MIN_PREFIX && word.indexOf(key) === 0;
  }

  /* Phrase keys ("true to size") match when the query holds the whole phrase,
     or when a query of two or more words is the start of the phrase
     ("made to"). A single word ("size") never matches a phrase by prefix. */
  function keyHits(qWords, qText, key) {
    if (key.indexOf(' ') < 0) {
      return topicWords(qWords).some(function (w) {
        return wordHits(w, key);
      });
    }
    if (qText.indexOf(key) >= 0) return true;
    return qWords.length > 1 && key.indexOf(qText) === 0;
  }

  function score(keys, qWords, qText) {
    return keys.reduce(function (total, key) {
      return keyHits(qWords, qText, key) ? total + (key.indexOf(' ') >= 0 ? 2 : 1) : total;
    }, 0);
  }

  function bestAnswer(topic, qWords, qText) {
    return topic.answers.reduce(function (best, answer) {
      var s = score(answer.keys, qWords, qText);
      return s > 0 && (!best || s > best.score) ? { answer: answer, score: s } : best;
    }, null);
  }

  function match(query) {
    var qWords = words(query);
    if (!topicWords(qWords).length) return [];
    var qText = qWords.join(' ');

    var hits = TOPICS.map(function (topic, index) {
      return { topic: topic, index: index, score: score(topic.keys, qWords, qText) };
    })
      .filter(function (hit) {
        return hit.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      });

    var links = [];
    hits.forEach(function (hit) {
      var found = bestAnswer(hit.topic, qWords, qText);
      links.push(
        found
          ? { title: found.answer.title, hint: hit.topic.title, url: hit.topic.url + '#' + found.answer.hash }
          : { title: hit.topic.title, hint: hit.topic.hint, url: hit.topic.url }
      );
    });

    /* One topic with a quick answer: add its guide page as the second link. */
    if (hits.length === 1 && links[0].url !== hits[0].topic.url) {
      links.push({ title: hits[0].topic.title, hint: hits[0].topic.hint, url: hits[0].topic.url });
    }

    return links.slice(0, MAX_LINKS);
  }

  window.twrdSearchGuides = { match: match };
})();
